import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import Spinner from "../Spinner";
import { Link } from "react-router-dom";

const GridCardHomeNews = () => {
  const [portfolioItems, setPortfolioItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasData, setHasData] = useState(false);

  useEffect(() => {
    getPortfolioData();
  }, []);

  const getPortfolioData = async () => {
    try {
      const response = await SendPostRequest("news/list");
      if (response?.data && response.data.length > 0) {
        setPortfolioItems(response.data);
        setHasData(true);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching portfolio data:", error);
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ minHeight: "300px" }}
        >
          <Spinner />
        </div>
      ) : hasData ? (
        <div
          id="portfolio-section"
          className="portfolio-section pad-bottom-80 pad-bottom-md-none  pt-5"
        >
          <div className="container">
            <div className="row">
              {/* Title Section */}
              <div className="offset-md-2 col-md-8">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-60">
                    <h2 className="title mb-0 text-uppercase">
                      Latest <span className="theme-color">News</span>
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>

              {/* Portfolio Items */}
              <div className="col-md-12">
                <div
                  className="row portfolio-wrap portfolio-classic px-4"
                  data-animation="fadeInUp"
                >
                  {/* Portfolio Items Grid - Removed filter buttons */}
                  {portfolioItems?.slice(0, 9)?.map((item) => (
                    <div
                      key={item.id}
                      className="portfolio-item portfolio-overlay-wrap home-news-grid-card col-lg-4 col-md-4 col-sm-4 col-xs-6 animated fadeInUp visible"
                    >
                      <div className="portfolio-thumb home-news-portfolio-thumb relative cleangrid-services-mobile-view">
                        <Link
                          to={`/news/detail/${item.slug}`}
                        >
                          <img
                            src={item.image}
                            className="img-fluid"
                            alt={item.title}
                          />
                        </Link>
                        <div className="portfolio-wrap">
                          <div className="portfolio-details-overlay">
                            <Link
                              to={`/news/detail/${item.slug}`}
                              rel="noopener noreferrer"
                            >
                              <h3 className="mb-3 grid-card-home-news">
                                {item.title}
                              </h3>
                            </Link>
                            <div className="portfolio-icons">
                              <Link
                                to={`/news/detail/${item.slug}`}
                                className="link-icon"
                                rel="noopener noreferrer"
                              >
                                <i className="icon-link text-white"></i>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default GridCardHomeNews;
